// src/pages/ReturnsPage.jsx
import Docs from "../Documents/Returnspolicy.pdf";
import React from "react";
import { theme } from "../utils/constants";

const cardStyle = {
  background: "#fff",
  borderRadius: "16px",
  padding: "2rem",
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
};

const headingStyle = {
  color: theme.primary,
  fontFamily: "'Roboto Slab', serif",
  marginBottom: "1rem",
};

export default function ReturnsPage() {
  return (
    <section
      style={{
        background: "#fafafa",
        padding: "5rem 24px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        {/* Page Heading */}

        <h1
          style={{
            textAlign: "center",
            fontSize: "2.8rem",
            fontFamily: "'Roboto Slab', serif",
            color: theme.text,
            position: "relative",
            marginBottom: "1rem",
          }}
        >
          Returns & Exchanges

          <span
            style={{
              position: "absolute",
              bottom: "-14px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "90px",
              height: "4px",
              background: theme.accent,
              borderRadius: "2px",
            }}
          />
        </h1>

        <p
          style={{
            textAlign: "center",
            color: "#666",
            fontSize: "1.1rem",
            maxWidth: "700px",
            margin: "0 auto 4rem",
            lineHeight: 1.8,
          }}
        >
          We want you to shop with confidence. If your purchase is
          defective, not fit for purpose, or you need assistance with an
          eligible return, we're here to help.
        </p>

        <div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap",
  }}
>
  <a
    href={Docs}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      background: "#fff",
      color: theme.primary,
      border: `2px solid ${theme.primary}`,
      padding: "1rem 2rem",
      borderRadius: "50px",
      textDecoration: "none",
      fontWeight: 600,
    }}
  >
    👁 View Policy
  </a>

  <a
    href="/documents/Upendo-Returns-and-Terms-Policy.pdf"
    download
    style={{
      background: theme.primary,
      color: "#fff",
      padding: "1rem 2rem",
      borderRadius: "50px",
      textDecoration: "none",
      fontWeight: 600,
    }}
  >
    📥 Download PDF
  </a>
</div>

        {/* Return Eligibility */}

        <div style={cardStyle}>
          <h2 style={headingStyle}>Return Eligibility</h2>

          <ul style={{ lineHeight: 2 }}>
            <li>Original proof of purchase is required.</li>
            <li>
              Items should be returned in their original packaging where
              possible.
            </li>
            <li>
              Change-of-mind returns may be requested within <strong>7 days</strong>{" "}
              of purchase, provided the item is unused or only lightly used.
            </li>
            <li>Sale items are not eligible for refunds.</li>
            <li>
              Customers are responsible for return shipping or transport
              costs.
            </li>
          </ul>
        </div>

        {/* Faulty Items */}

        <div style={{ ...cardStyle, marginTop: "2rem" }}>
          <h2 style={headingStyle}>Faulty or Incorrect Items</h2>

          <p style={{ lineHeight: 1.9 }}>
            If an item is defective, unsafe, or not fit for its intended
            purpose, it may qualify for a repair, replacement, or refund in
            accordance with applicable warranty standards and the Competition
            and Consumer Protection Act.
          </p>

          <ul style={{ lineHeight: 2 }}>
            <li>Stop using the item immediately.</li>
            <li>Contact Upendo Store as soon as possible.</li>
            <li>Return the item without tampering with it.</li>
            <li>
              Our team will inspect the item before approving a refund,
              replacement, or repair.
            </li>
          </ul>
        </div>

        {/* How to Return */}

        <div style={{ ...cardStyle, marginTop: "2rem" }}>
          <h2 style={headingStyle}>How to Return an Item</h2>

          <ol style={{ lineHeight: 2 }}>
            <li>Contact our customer service team.</li>
            <li>Keep the item and packaging in good condition.</li>
            <li>Provide your receipt or other proof of purchase.</li>
            <li>Return the item to our store.</li>
            <li>Our team will inspect the product.</li>
            <li>
              If approved, your refund, repair, or replacement will be
              processed.
            </li>
          </ol>
        </div>

        {/* Refunds */}

        <div
          style={{
            marginTop: "2rem",
            background: theme.primary,
            color: "#fff",
            padding: "2rem",
            borderRadius: "16px",
          }}
        >
          <h2
            style={{
              marginTop: 0,
              fontFamily: "'Roboto Slab', serif",
            }}
          >
            Refund Timeline
          </h2>

          <p style={{ lineHeight: 1.8 }}>
            Approved refunds are processed within{" "}
            <strong>5–10 business days</strong> using the original payment
            method.
          </p>

          <p style={{ lineHeight: 1.8 }}>
            If your refund has not appeared after this period, please contact
            your bank or card issuer, as processing times may vary.
          </p>
        </div>

        {/* Exchanges */}

        <div style={{ ...cardStyle, marginTop: "2rem" }}>
          <h2 style={headingStyle}>Exchanges</h2>

          <ul style={{ lineHeight: 2 }}>
            <li>Exchanges are available for eligible products.</li>
            <li>
              If an exchange is not possible, an approved refund will be
              issued instead.
            </li>
            <li>
              Defective products may qualify for repair, replacement, or
              refund.
            </li>
          </ul>
        </div>

        {/* Important Notes */}

        <div style={{ ...cardStyle, marginTop: "2rem" }}>
          <h2 style={headingStyle}>Important Notes</h2>

          <ul style={{ lineHeight: 2 }}>
            <li>Sale items cannot be refunded.</li>
            <li>
              Customers are responsible for return shipping costs unless
              otherwise required by law.
            </li>
            <li>
              Counterfeit product investigations may take up to{" "}
              <strong>30 days</strong>.
            </li>
            <li>
              All returned products undergo an inspection before approval.
            </li>
          </ul>
        </div>

        {/* Order Cancellation */}

        <div style={{ ...cardStyle, marginTop: "2rem" }}>
          <h2 style={headingStyle}>Order Cancellation</h2>

          <p style={{ lineHeight: 1.9 }}>
            Under the Competition and Consumer Protection Act, orders cannot
            normally be cancelled simply because a customer changes their
            mind.
          </p>

          <p style={{ lineHeight: 1.9 }}>
            Refunds or cancellations may be available where goods are
            defective, unsafe, not fit for purpose, or where a paid service
            has not been provided.
          </p>
        </div>

        {/* Contact */}

        <div
          style={{
            marginTop: "3rem",
            background: theme.accent,
            color: "#fff",
            borderRadius: "16px",
            padding: "2.5rem",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              marginTop: 0,
              fontFamily: "'Roboto Slab', serif",
            }}
          >
            Need Help?
          </h2>

          <p style={{ lineHeight: 1.8 }}>
            Our customer service team is happy to assist with returns,
            exchanges, refunds, or order cancellations.
          </p>

          <p
            style={{
              fontSize: "1.25rem",
              fontWeight: 600,
              marginBottom: 0,
            }}
          >
            📞 +260 573 305986
          </p>
        </div>
      </div>
    </section>
  );
}